import { useEffect, useState } from "react";
import CalculateInvoiceWrapper from "./calculateInvoiceWrapper";

export default function View() {
    return (
        <CalculateInvoiceWrapper />
    )
}